import React from 'react';
import { Md as CardMD } from '@/card/components/card';
import { numberStartsWithDollarSign } from '@/utils/string-utils';
import {
  Account,
  AccountStats,
  AccountsWrapper,
  HorizontalMeter,
  RankingAccountName,
} from './most-active-accounts-styles';

const accountTypes = {
  host: 'host',
  owner: 'owner',
};

const accountTitles = {
  [accountTypes.host]: 'Most Active Hosts',
  [accountTypes.owner]: 'Most Active Owners',
};

const cardNames = {
  [accountTypes.host]: 'MOST_ACTIVE_HOSTS',
  [accountTypes.owner]: 'MOST_ACTIVE_OWNERS',
};

function MostActiveAccounts(props) {
  const {
    type,
    onClickHandlers,
    handleHideShowCards,
    mostActiveAccounts,
    optionsOverride,
  } = props;

  const aggRevenues = mostActiveAccounts.map((account) => account.aggRevenue);
  const maxAggRevenue = Math.max(...aggRevenues);

  return (
    <CardMD
      title={accountTitles[type]}
      onClickHandlers={onClickHandlers}
      onHide={() => handleHideShowCards([cardNames[type]], true)}
      optionsOverride={optionsOverride}
    >
      <AccountsWrapper>
        {mostActiveAccounts.map((account, idx) => (
          <div key={idx}>
            <Account isOwner={type === accountTypes.owner}>
              <RankingAccountName
                name={account.name}
                ranking={idx + 1}
                isOwner={type === accountTypes.owner}
              />
              <AccountStats
                revenue={numberStartsWithDollarSign(account.aggRevenue)}
                propertyCount={account.propertyCount}
              />
            </Account>
            <HorizontalMeter
              isOwner={type === accountTypes.owner}
              score={account.aggRevenue}
              maxScore={maxAggRevenue}
              position={idx}
            />
          </div>
        ))}
      </AccountsWrapper>
    </CardMD>
  );
}

export function MostActiveHosts(props) {
  return <MostActiveAccounts type={accountTypes.host} {...props} />;
}

export function MostActiveOwners(props) {
  return <MostActiveAccounts type={accountTypes.owner} {...props} />;
}
